class Common {
  constructor () {
    let _this = this;
    this.oldBrowser();
    this.myHeader();
    this.menuOpen();
    this.parallaxBandeau();
    this.sizeSearch();
    this.openSearch();
    this.menu();
    this.fixIe();
    this.submitSearch();
    this.searchHeader();
    this.nbElemToShow();
    this.newsletterFooter();
    this.displayArrowScrollTop();
    this.smoothscrollTop();
    this.targetBlankMainMenu();
    this.targetBlankRSFooter();
    this.targetBlankContent();
    window.addEventListener("resize", function() {
      _this.myHeader();
    }, false);
  }

  oldBrowser() {
    // Message navigateur obsolète
    var $buoop = {c:2};
    function $buo_f(){
      var e = document.createElement("script");
      e.src = "//browser-update.org/update.min.js";
      document.body.appendChild(e);
    }
    try {document.addEventListener("DOMContentLoaded", $buo_f,false)}
    catch(e){window.attachEvent("onload", $buo_f)}
  }


  myHeader () {
    if (window.matchMedia('(min-width: 1291px)').matches) {
      let myMarge = $('#header-top .btn').outerWidth();
      $('#header-main').width($(window).width() - (myMarge * 2))
    } else {
      $('#header-main').width('100%')
    }
  }

  menuOpen() {
    Array.prototype.forEach.call(document.querySelectorAll('header #header-main [id*="block-fcpe-main-menu"] > ul > li'), function (elem) {
      elem.addEventListener('click', function (ev) {
        if (window.outerWidth < 981) this.classList.toggle('on');
      });
    })
  }

  parallaxBandeau() {
    if (!$('body').hasClass('page-node-type-page-introuvable')){
      if (document.querySelector('.block-bandeau')) {
        let bandeau = document.querySelector('div.block-bandeau div.field--name-field-image');
        if (bandeau && !bandeau.classList.contains('rellax')) {
          bandeau.classList.add('rellax');
          bandeau.setAttribute('data-rellax-speed', 6)
        }
      }
      if (document.querySelector('.rellax')) new Rellax('.rellax');
    }
  }

  iframeNl () {
    if (document.querySelector('#modal_nl')) {
      let allNl = document.querySelectorAll('.layout-content .views-row > .nl-teaser, .path-espace-perso .nl-mea, .path-espace-perso .btn-nl')
      let modal = document.querySelector('#modal_nl');
      let iframe = modal.querySelector('iframe');
      modal.querySelector('.icon-close').addEventListener('click', function () {
        modal.style.display = 'none'
      });
      Array.prototype.forEach.call(allNl, function (e) {
        e.addEventListener('click', function (ev) {
          ev.preventDefault();
          iframe.src = e.dataset.nl;
          modal.style.display = 'flex'
        })
      })
    }
  }

  sizeSearch () {
    var searchWidth = $('#header .search-block-form .btn-search').width() + $('#header #block-fcpe-main-menu ul').width()
    $('#header .search-block-form form').width(searchWidth)
  }

  submitSearch() {
    document.querySelector('.form-item-keys').innerHTML += '<i class="icon-search" id="real-search">&nbsp;</i>';
    document.querySelector('#header .search-block-form .form-item-keys > i#real-search').addEventListener('click', function (ev) {
      if ($('#header .search-block-form, #header .search-block-form form').hasClass('on')) {
        $('form#search-block-form').submit()
      }
    });
  }

  openSearch () {
    document.querySelector('#header .search-block-form .btn-search').addEventListener('click', function (ev) {
      this.classList.toggle('on');
      $('#header .search-block-form, #header .search-block-form form').toggleClass('on')
      if ($('#header .search-block-form, #header .search-block-form form').hasClass('on')) {
        $('#header .search-block-form, #header .search-block-form form input').focus()
      }
    })
  }

  menu () {
    $('header #btnMenu').click(function () {
      $(this).toggleClass('on')
      $('header #header').toggleClass('on')
    })
  }

  fixIe () {
    $(window).on('load',function () {
      if (navigator.userAgent.match(/Trident\/7\./)) {
        if ($('body').hasClass('page-node-type-campagne') || $('body').hasClass('page-node-type-page-adherer') || $('body').hasClass('page-node-type-article') || $('body').hasClass('path-user') && $('.user-register-form').length || $('body').hasClass('path-inscription-newsletter') || $('body').hasClass('page-node-type-qui-sommes-nous'))  {
          $('main > .container').addClass('fix-ie')
        }
        if($('body').hasClass('path-espace-perso')){
          $('main .layout-introduction').addClass('fix-ie')
        }
      }
    })
  }

  searchHeader () {
    $('#search-block-form input.form-search').attr('placeholder', 'Veuillez renseigner les termes exacts à rechercher (+ de 3 caractères)');
  }

  nbElemToShow () {
    let form = document.querySelector('form.views-exposed-form');
    if (form) {
      form.querySelector('select').addEventListener('change', function (e) {
        form.querySelector('input[type="submit"]').click();
      })
    }
  }

  newsletterFooter() {
    $('footer #block-newsletterblock-2 .js-form-type-email input').attr('placeholder', "Inscription newsletter")
  }

  smoothscrollTop() {
    $('.fleche-scrolltop').click(function(){
      $('html, body').animate({
        scrollTop: 0
      }, 'slow');
    });
  }

  displayArrowScrollTop() {
    $(document).on('scroll ready', function() {
      if($(window).scrollTop() >= $(window).height()){
        $('.fleche-scrolltop').removeClass('opacity0');
      }
      else{
        if(!$('.fleche-scrolltop').hasClass('opacity0')){
          $('.fleche-scrolltop').addClass('opacity0');
        }
      }
    });
  }

  targetBlankMainMenu() {
    $(window).on('load',function(){
      $('#block-navigationprincipale .nav a, #block-fcpe-main-menu .nav a').each(function(){
        if($(this).html()== 'La boutique'){
          $(this).attr('target', '_blank');
        }
      });
    })
  }

  targetBlankRSFooter() {
    $(window).on('load',function(){
      $('div[id^="block-listereseauxsociaux"] .field__item a').attr('target', '_blank');
    })
  }

  targetBlankContent() {
    if($('#infos-pratiques').length){
      $('#infos-pratiques').find('p a').attr('target', '_blank');
    }
  }
}

export default Common
